import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useProductCategoryUpdateMutation } from '@occc-app/dataAccessLayer/productCategory/mutations';
import { useGetProductCategoryById } from '@occc-app/dataAccessLayer/productCategory/queries';

import { UpdateProductCategoryPage } from './UpdateProductCategoryPage';

import { routeCreator } from '../utils';
import { ProductCategoryFormValues } from '../types';
import { validateProductCategory } from '../validation';

export const UpdateProductCategoryPageContainer: React.FC = () => {
  const navigate = useNavigate();
  const { id = '' } = useParams<{ id: string }>();

  const { loading, error, data } = useGetProductCategoryById(id);
  const loaded = !!data;

  const initialValues: ProductCategoryFormValues = React.useMemo(() => {
    return {
      name: data?.name,
      categoryRestriction: data?.categoryRestriction ?? 'None',
      rank: data?.rank,
    };
  }, [data]);

  const onCompleted = () => navigate(routeCreator.details(id));
  const [updateProductCategoryMutation] = useProductCategoryUpdateMutation({
    refetchQueries: ['productCategory'],
    onCompleted,
  });

  const update = (values: ProductCategoryFormValues) => {
    const { name, categoryRestriction, rank } = values;

    if (!name) {
      return;
    }

    return updateProductCategoryMutation({
      variables: {
        input: {
          name,
          categoryRestriction: categoryRestriction === 'None' ? null : categoryRestriction,
          rank,
          id,
        },
      },
    });
  };

  return (
    <UpdateProductCategoryPage
      update={update}
      validate={validateProductCategory}
      initialValues={initialValues}
      loading={loading}
      loaded={loaded}
      error={error}
    />
  );
};
